// components

// react
import { useEffect, useState } from 'react';
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import { BeatLoader } from 'react-spinners';

// kendo
import kendo from "@progress/kendo-ui";

// css
import styles from "./userList_mobile.module.css"
// services

function UserListItemMobile({conn, item}) {
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  // 대상자 정보로 보내줄 데이터 셋팅
  const userTerm = item.userTerm;
  const meainStatCode = item.meainStatCode;
  const meainStatTerm = item.meainStatTerm;
  const dataStatSctCodeNo = item.dataStatSctCodeNo;
  const dataStatTerm = item.dataStatTerm;
  const latestDataStatTime = item.latestDataStatTime;
  const movement = item.movement;
  const temperature = item.temperature;
  const humidity = item.humidity;
  const co2 = item.co2;
  const light = item.light;
  const cid = item.cid;
  const bizType = item.bizType;
  const userId = item.userId;
  // 대상자 상세정보로 보내줄 데이터 셋팅
  const birthday = item.birthday;
  const userGender = item.userGender;
  const dongTerm = item.dongTerm;
  const address = item.address;
  const userPhone = item.userPhone;
  const protectorPhone = item.protectorPhone;
  const sickType = item.sickType;
  const note = item.note;

  // 대상자 정보 페이지 이동
  const goUserInfo = () => {
    history.push({
      pathname: "/user/info",
      state: {
         userTerm, meainStatCode, meainStatTerm, dataStatSctCodeNo, dataStatTerm, latestDataStatTime, movement, temperature, humidity, co2, light, cid, bizType, userId,
         birthday, userGender, dongTerm, address, userPhone, protectorPhone, sickType, note
        },
    });
  }

  // 성별 이미지 표출
  const genderImg = () => {
    if (item.userGender === "M") {
      return <img className={styles.genderImg} src="/images/mobile/icon_man.png"></img>;
    } else {
      return <img className={styles.genderImg} src="/images/mobile/icon_woman2.png"></img>;
    }
  }


  // 대상자 이벤트 표시
  const userEvent = () => {
    if(item.meainStatCode === "20001") {
      return <img className={styles.eventImg_m} src="/images/mobile/normal.png"></img>
    } else if(item.meainStatCode === "20002") {
      return <img className={styles.eventImg_m} src="/images/mobile/warn.png"></img>
    } else if(item.meainStatCode === "20003") {
      return <img className={styles.eventImg_m} src="/images/mobile/off.png"></img>
    } else if(item.meainStatCode === "20004") {
      return <img className={styles.eventImg_m} src="/images/mobile/danger.png"></img>
    } else {
      return <img className={styles.eventImg_m} src="/images/mobile/normal.png"></img>
    }
  }

  // 대상자 상태 표시
  const stateImg = () => {
    if(item.meainStatCode === "20003" || item.meainStatCode == "20005") {
      return <img className={styles.stateImg} src="/images/mobile/con_04_b.png"></img>
    } else {
      if(item.dataStatTerm === "고활동") {
        return <img className={styles.stateImg} src="/images/mobile/con_01_b.png"></img>
      } else if(item.dataStatTerm === "저활동") {
        return <img className={styles.stateImg} src="/images/mobile/con_05_b.png"></img>
      } else if(item.dataStatTerm === "수면") {
        return <img className={styles.stateImg} src="/images/mobile/con_06_b.png"></img>
      } else if(item.dataStatTerm === "수면불안") {
        return <img className={styles.stateImg} src="/images/mobile/con_06_b.png"></img>
      } else if(item.dataStatTerm === "식사") {
        return <img className={styles.stateImg} src="/images/mobile/con_03_b.png"></img>
      } else if(item.dataStatTerm === "자리비움") {
        return <img className={styles.stateImg} src="/images/mobile/con_02_b.png"></img>
      } else {
        return <img className={styles.stateImg} src="/images/mobile/con_04_b.png"></img>
      }
    }
  }

  // 상태명 설정
  const stateTerm = () => {
    if(item.meainStatCode === "20003") {
      return <span className={styles.stateTerm}>미작동</span>
    } else {
      return <span className={styles.stateTerm}>{item.dataStatTerm}</span>
    }
  }

  // 대상자 상태 지속시간
  const stateTime = () => {
    let text;
    let hour;
    let min;
  
    if ( item.meainStatTerm === "미작동" ) {
      text = "-"
    } else if ( item.meainStatTerm === "설치예정" ) {
      text = "-"
    } else {
      if ( item.latestDataStatTime ) {
        hour = parseInt(item.latestDataStatTime/60)
        min = item.latestDataStatTime%60
        if ( hour === 0 ) {
          text = min + "분"    
        } else {
          text = hour + "시간 " + min + "분"  
        }
      } else {
        text = "계산중"
      }
    }

    return <span className={styles.stateTime}>{text}</span>;
  }

  // 대상자 이벤트 색상
  const eventBackground = () => {
    if(item.meainStatCode === "20001") {
      return "#1f6310"
    } else if(item.meainStatCode === "20002") {
      return "#dfc42d"
    } else if(item.meainStatCode === "20003") {
      return "#aaaaa7"
    } else if(item.meainStatCode === "20004") {
      return "#d42c2c"
    } else {
      return "#aaaaa7"
    }
  }

  useEffect(() => {
  }, [])

  return (
    <>
      <div className={styles.userListItem_m} onClick={goUserInfo}>
        <div className={styles.item1} style={{backgroundColor: eventBackground()}}>
          <div className={styles.item1_1}>{item.userTerm}({item.dongTermSimple})</div>
          <div className={styles.item1_2}>{item.birthday}{genderImg()}</div>
          {
            item.dangerYn === "Y" &&
            <div className={styles.item1_3}>관리대상자</div>
          }
        </div>
        <div className={styles.item2}>
          <div className={styles.item2_1}>
            <div className={styles.item2_1_1}>{stateImg()}</div>
            <div className={styles.item2_1_2}>
              <div>{stateTerm()}</div>
              <div>{stateTime()}</div>
            </div>
          </div>
          {(item.dataStatTerm === "자리비움" && item.behaviorCode && item.behaviorCode !== "B00") &&
            <div className={styles.item2_2}>
              {item.behaviorTerm} 외출 예상
            </div>
          }
          {(item.dataStatTerm === "자리비움" && item.behaviorCode && item.behaviorCode === "B00") &&
            <div className={styles.item2_2}>
              {item.behaviorTermOther} 외출 예상
            </div>
          }
        </div>
        <div className={styles.item3}>
          <span>상세정보</span>
          <img className={styles.detailBtn_m} src="/images/mobile/plus_btn.png"></img>
        </div>
        {/* <div className={styles.userListItemTop_m}>
          <span className={styles.userListItemUser_m}>&nbsp;{item.userTerm} <span style={{fontSize: "3vw"}}>({item.rgnTermSimple} {item.dongTermSimple})</span></span>
        </div>
        <ul className={styles.userListItemBottom_m}>
          <li className={styles.userListItemBottomL_m} style={{backgroundColor: eventBackground()}}>
            {userState()}
            {stateTerm()}
          </li>
          <li className={styles.userListItemBottomR_m}>
            <span>상태<br/>자세히보기</span>
            <img className={styles.detailBtn_m} src="/images/mobile/plus_btn.png"></img>
          </li>
        </ul> */}
      </div>
      {loading && (
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}>
          <BeatLoader loading={true} size={18} color="#5e9dd4" />
        </p>
      )}
    </>
  );
}

export default UserListItemMobile;
